// RELATE Beauty – Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // ─── Newsletter Popup ─────────────────────────────────
  const POPUP_KEY = 'relate_popup_dismissed';
  const backdrop = document.getElementById('newsletter-popup');
  const closeBtn = document.getElementById('popup-close');
  const dismissBtn = document.getElementById('popup-dismiss');
  const form = document.getElementById('popup-form');
  const successEl = document.getElementById('popup-success');
  const nameInput = document.getElementById('popup-name');

  if (backdrop && !localStorage.getItem(POPUP_KEY)) {
    setTimeout(function () {
      backdrop.classList.add('is-open');
    }, 2500);
  }

  function closePopup() {
    if (backdrop) {
      backdrop.classList.remove('is-open');
      localStorage.setItem(POPUP_KEY, '1');
    }
  }

  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (dismissBtn) dismissBtn.addEventListener('click', closePopup);
  if (backdrop) {
    backdrop.addEventListener('click', function (e) {
      if (e.target === backdrop) closePopup();
    });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const firstName = nameInput ? nameInput.value.split(' ')[0] : 'there';
      if (successEl) {
        const h = successEl.querySelector('.popup__success-heading');
        if (h) h.textContent = "You're in, " + firstName + ".";
        form.closest('.popup__inner').style.display = 'none';
        successEl.style.display = 'flex';
      }
      localStorage.setItem(POPUP_KEY, '1');
      setTimeout(closePopup, 2200);
    });
  }

  // ─── Cart count update ────────────────────────────────
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-count').forEach(el => {
          el.textContent = cart.item_count;
        });
      });
  }
  updateCartCount();

});
